export enum Environment {
  PRODUCTION = "prod",
  STAGING = "staging",
  TEST = "test",
  LOCAL = "local",
  UNKNOWN = "unknown",
}

const HOSTS = {
  production: "customer.cloud.carbonrobotics.com",
  staging: "customer.stg.cloud.carbonrobotics.com",
  test: "customer.dev.cloud.carbonrobotics.com",
  localDev: "devlocal.carbonrobotics.com",
};

export const getEnvironment = (): Environment => {
  if (typeof window === "undefined") {
    return Environment.UNKNOWN;
  }
  const host = window.location.hostname;
  switch (host) {
    case HOSTS.production: {
      return Environment.PRODUCTION;
    }
    case HOSTS.staging: {
      return Environment.STAGING;
    }
    case HOSTS.test: {
      return Environment.TEST;
    }
    case HOSTS.localDev: {
      return Environment.LOCAL;
    }
    default: {
      return Environment.UNKNOWN;
    }
  }
};

export const isProduction = getEnvironment() === Environment.PRODUCTION;
export const isStaging = getEnvironment() === Environment.STAGING;
export const isTest = getEnvironment() === Environment.TEST;
export const isJestTest = process.env.NODE_ENV === "test";
export const isLocal = getEnvironment() === Environment.LOCAL;
export const isDevelopment = !isProduction && !isStaging;
